__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "account-list-mfe-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.13.5", () => (Promise.all([__webpack_require__.e(249), __webpack_require__.e(914), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(97249))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(755)]).then(() => (() => (__webpack_require__(69282))))));
			register("@tanstack/match-sorter-utils", "8.19.4", () => (__webpack_require__.e(22).then(() => (() => (__webpack_require__(46022))))));
			register("@tanstack/react-table", "8.21.2", () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(61072))))));
			register("antd", "5.24.5", () => (Promise.all([__webpack_require__.e(836), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(321)]).then(() => (() => (__webpack_require__(88836))))));
			register("driver.js", "1.4.0", () => (__webpack_require__.e(741).then(() => (() => (__webpack_require__(69741))))));
			register("graphql", "16.10.0", () => (__webpack_require__.e(926).then(() => (() => (__webpack_require__(37926))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(468).then(() => (() => (__webpack_require__(35468))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))));
			register("lottie-react", "2.4.1", () => (Promise.all([__webpack_require__.e(51), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(18051))))));
			register("lucide-react", "0.503.0", () => (Promise.all([__webpack_require__.e(136), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(43136))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(68154))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(336)]).then(() => (() => (__webpack_require__(69733))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("recharts", "2.15.1", () => (Promise.all([__webpack_require__.e(940), __webpack_require__.e(914), __webpack_require__.e(919)]).then(() => (() => (__webpack_require__(65940))))));
			register("ts-utils-lib", "0.0.7", () => (Promise.all([__webpack_require__.e(236), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(67236))))));
			register("uuid", "10.0.0", () => (__webpack_require__.e(419).then(() => (() => (__webpack_require__(93419))))));
			register("zustand", "4.5.6", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(34085))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};